import React, { useState } from 'react';
import { ActionIcon } from '@mantine/core';
import { IconStar, IconStarFilled } from '@tabler/icons-react';
import { notifications } from '@mantine/notifications';
import { authFetch, parseJsonResponse } from '../lib/api';
import { getAccentColor } from '../lib/jlfcTheme';

export default function LandingPageButton({ user, route, onUserUpdate }) {
  const [saving, setSaving] = useState(false);
  const active = Boolean(route) && user?.landing_route === route;

  const toggle = async () => {
    const next = active ? null : route;
    setSaving(true);
    try {
      const res = await authFetch('/api/me', {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ landing_route: next }),
      });
      const data = await parseJsonResponse(res);
      if (!res.ok || !data.success) {
        notifications.show({
          title: 'Erreur',
          message: data.message || 'Enregistrement impossible',
          color: 'red',
        });
        return;
      }
      onUserUpdate?.({ landing_route: data.user?.landing_route || null });
    } catch {
      notifications.show({ title: 'Erreur', message: 'Erreur réseau', color: 'red' });
    } finally {
      setSaving(false);
    }
  };

  return (
    <ActionIcon
      type="button"
      variant="subtle"
      size="sm"
      color={active ? getAccentColor() : 'gray'}
      loading={saving}
      aria-label={active ? 'Retirer la page d’accueil' : 'Définir comme page d’accueil'}
      onClick={toggle}
    >
      {active ? <IconStarFilled size={16} /> : <IconStar size={16} />}
    </ActionIcon>
  );
}
